import lodash from "lodash";
import {questionOptions} from "@/modules/forms/constants/pre-defined-question-options";

export default class QuestionOptions {
    constructor(
        options = questionOptions.check.multiChoice
    ) {
        this.options = lodash.cloneDeep(options);
    }

    getOptions() {
        return this.options
    }
}